import React, {useContext, useEffect, useState} from "react";
import {useHistory} from "react-router-dom";
import {TranslateContext} from "../../context/TranslateContext";
import {deleteGruppoUtenteApi, getGruppiUtenteApi} from "./services/GruppiUtentiServices";
import ConfGruppiUtenteView from "./ConfGruppiUtenteView";

export default function ConfGruppiUtenteController() {

    const [loadingData, setLoadingData] = useState(true);

    const [gruppi, setGruppi] = useState([]);
    const [gruppoSel, setGruppoSel] = useState(null);
    const [showConfirm, setShowConfirm] = useState(false);
    const [show, setShow] = useState(false);
    const [modalMsg, setModalMsg] = useState('');

    const {translate} = useContext(TranslateContext);
    const history = useHistory();

    async function getGruppi() {
        const response = await getGruppiUtenteApi();
        setGruppi(response.data.data);
        setLoadingData(false);
    }

    useEffect(() => {
        getGruppi();
    }, []);

    const eliminaGruppoUtente = async () => {
        setShowConfirm(false);
        const response = await deleteGruppoUtenteApi(gruppoSel.id_gruppo_utente);
        if (response.data.result === -1) {
            setModalMsg(response.data.description)
            setShow(true)
        } else {
            setGruppi(response.data.data);
        }
    }

    const bottoniDx = [
        {
            label: translate("Aggiungi Frequenza"),
            icon: "fas fa-plus-circle",
            command: () => {
                history.push("/upd-gruppo-utente");
            }
        }
    ];

    function onClickElimina(row) {
        setGruppoSel(row)
        setShowConfirm(true);
    }

    function onRowDbClick(row) {
        history.push("/upd-gruppo-utente/" + row.id_gruppo_utente);
    }

    return (
        <ConfGruppiUtenteView
            show={show}
            setShow={setShow}
            modalMsg={modalMsg}
            translate={translate}
            loadingData={loadingData}
            showConfirm={showConfirm}
            gruppi={gruppi}
            setShowConfirm={setShowConfirm}
            eliminaGruppoUtente={eliminaGruppoUtente}
            gruppoSel={gruppoSel}
            bottoniDx={bottoniDx}
            onClickElimina={onClickElimina}
            onRowDbClick={onRowDbClick}
        />
    );
}